import './App.css';
import { BrowserRouter as Router } from 'react-router-dom'
import RouteContainer from './RouteContainer';
import {ContextProvider} from "./Context";
import LimitErrorProvider from "./components/limit_error_provider/LimitErrorProvider";

function App() {
  return (
    <div className="App">
        <ContextProvider>
            <Router>
                <LimitErrorProvider>
                    <RouteContainer/>
                </LimitErrorProvider>
            </Router>
        </ContextProvider>
    </div>
  );
}

export default App;
